import React, { useState } from 'react'
import { Sms } from '/components/SMS/'
import { Codes } from '/components/Codes/'
import { Countdown } from '/components/Countdown/'
import { CodeVerification } from '/components/SMS/'
import { useEffect } from 'react'

export const SmsValidation = ({ pin, smsSent }) =>
  (() => {
    const [step, setStep] = useState()

    const [state, setState] = useState({
      products: [],
      accessToken: '',
      canSendANewSms: false,
    })

    useEffect(() => {
      if (smsSent && step != 1) {
        setStep(2)
      } else {
        setStep(1)
      }
    }, [])

    const nextSmsReadyCallback = (canSendANewSms = false) => {
      setState({ canSendANewSms })
      setStep(1)
    }

    const smsSentCallback = ({ canSendANewSms = false }) => {
      setState({ canSendANewSms })
      setStep(2)
    }

    const verifiedCodeCallback = ({ fetchedProducts, accessToken }) => {
      setState({ products: fetchedProducts, accessToken })
      setStep(3)
    }

    const countdownCallback = () => {
      setStep(4)
    }

    if (step === 1) {
      return <Sms pin={pin} smsSentCallback={smsSentCallback} />
    } else if (step === 2) {
      return (
        <CodeVerification
          pin={pin}
          verifiedCodeCallback={verifiedCodeCallback}
          nextSmsReadyCallback={nextSmsReadyCallback}
          canSendANewSms={state.canSendANewSms}
        />
      )
    } else if (step === 3) {
      return <Countdown countdownCallback={countdownCallback} timeLeft={2} />
    } else if (step === 4) {
      return (
        <Codes
          fetchedProducts={state.products}
          pin={pin}
          accessToken={state.accessToken}
        />
      )
    } else {
      return null
    }
  })()
